
export enum ButtonStyle {
    StandardPrimary = 1,
    StandardDefault = 2,
    StandardTransparent = 5
}